export default "__VITE_ASSET__b1080ac1__"